import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useParams,
} from "react-router-dom";
import TradeGPT from "./components/TradeGPT";
import { v4 as uuidv4 } from "uuid";
import Faq from "./components/Faq";
import SharedChat from "./components/Share/SharedChat";
import ThankYou from "./components/ThankYou";
import TermsAndPolicies from "./components/terms_and_policies/TermsAndPolicies";
import TermsOfService from "./components/terms_and_policies/TermsOfService";
import PrivacyPolicy from "./components/terms_and_policies/PrivacyPolicy";
import LegalDisclaimer from "./components/terms_and_policies/LegalDisclaimer";
import TakeDownPolicy from "./components/terms_and_policies/TakeDownPolicy";
import NotFoundPage from "./components/404page";
import Session from "./components/Session/Session";
import SignIn from "./components/SignInP";
import SignUp from "./components/SignUpP";
import AppWrapper from "./components/AppWrapper";
import DeletedAccountPage from "./components/DeletedAccountPage";
import LocationListener from "./components/LocationListener";

import ConfidentialsWrapper from "./components/ConfidentialsWrapper";
import AuthRoutes from "./components/AuthRoute";
import WebsocketWrapper from "./components/Sidebar/WebsocketWrapper";
import MainLayout from "./layouts/MainLayout";
import Dashboard from "./components/Dashboard/Dashboard";
import ChangeLogsPage from "./components/ChangeLogsPage";
import NotificationWrapper from "./layouts/NotificationWrapper";
import AuthPageLayout from "./layouts/AuthPageLayout";
import { lazy, Suspense } from "react";
import LoadingPage from "./components/LoadingPage";
import TaskDashboard from "./components/Tasks";

const PlansWrapper = lazy(() => import("./components/Plans/PlansWrapper"));

const AppRoutes = () => {
  return (
    <Router>
      <AppWrapper>
        <ConfidentialsWrapper>
          <WebsocketWrapper>
            <Routes>
              <Route element={<LocationListener />}>
                <Route
                  path="/signup"
                  element={(
                    <AuthPageLayout>
                      <SignUp />
                    </AuthPageLayout>
                  )}
                />
                <Route
                  path="/signin"
                  element={(
                    <AuthPageLayout>
                      <SignIn />
                    </AuthPageLayout>
                  )}
                />
                <Route
                  path="/"
                  element={
                    <AuthRoutes />
                  }
                />
                <Route element={<MainLayout />}>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route
                    path="/tasks"
                    element={(
                      <NotificationWrapper>
                        <TaskDashboard />
                      </NotificationWrapper>
                    )}
                  />
                  <Route
                    path="/plans"
                    element={(
                      <Suspense fallback={<LoadingPage />}>
                        <PlansWrapper />
                      </Suspense>
                    )}
                  />
                  <Route path="/faq" element={<Faq />} />
                  <Route path="/chat" element={<Navigate to={`/chat/${uuidv4()}`} />} />
                  <Route
                    path="/chat/:session_id"
                    element={(
                      <NotificationWrapper>
                        <TradeGPT key={useParams().session_id} />
                      </NotificationWrapper>
                    )}
                  />
                  <Route path="/release-notes" element={<ChangeLogsPage />} />
                </Route>
                <Route path="/session" element={<Session />} />
                <Route path="/share/:session_id/:title?" element={<SharedChat />} />
                <Route path="/thank-you" element={<ThankYou />} />
                <Route path="/policies" element={<TermsAndPolicies />} />
                <Route path="/policies/service-terms" element={<TermsOfService />} />
                <Route path="/policies/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/account-deleted" element={<DeletedAccountPage />} />
                <Route path="*" element={<NotFoundPage />} />
                <Route
                  path="/policies/legal-disclaimer"
                  element={<LegalDisclaimer />}
                />
                <Route
                  path="/policies/take-down-policy"
                  element={<TakeDownPolicy />}
                />
              </Route>
            </Routes>
          </WebsocketWrapper>
        </ConfidentialsWrapper>
      </AppWrapper>
    </Router>
  );
};

export default AppRoutes;
